<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div :class="['testimonial-block__content-area columns is-variable is-6', {'is-mobile': !is_mobile}]">
            <div class="column is-4">
                <h2 v-if="block.title" :class="['title', block.title_colour]">{{block.title}}</h2>
            </div>
            <div class="column is-8">
                <div class="content" v-if="block.content" ref="content" v-html="block.content"></div>
            </div>
        </div>
        <div class="view-list" v-if="this.block.view_items && this.block.view_items.list.length > 0">
            <component v-for="item,i in this.block.view_items.list" :is_mobile="is_mobile" :key="i" :is="item.type" :item="item" />
        </div>
        <div class="cta block-cta" v-if="!all_loaded">
            <div class="columns is-variable is-6">
                <div class="column is-offset-4">
                    <button @click.prevent="fetch" :class="['button bg-orange is-rounded', {'is-loading': is_loading}]">LOAD MORE</button>
                </div>
            </div>
        </div>
        <div class="cta block-cta" v-if="this.block.view_items.pages != 1 && all_loaded">
            <div class="columns is-variable is-6">
                <div class="column is-offset-4">- All Loaded -</div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import WindowResizeHandler from '@/components/mixins/WindowResizeHandler';
import * as components from './elements'
export default {
    name        :   'TestimonialBlock',
    mixins      :   [ BlockCommons, WindowResizeHandler ],
    components,
    data()
    {
        return {
            is_mobile   :   false,
            is_loading  :   false,
            page        :   1,
            all_loaded  :   this.block.view_items.pages == 1
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods     :   {
        handle_window_resize(width)
        {
            this.is_mobile  =   width <= 640;
        },
        fetch()
        {
            if (this.is_loading || this.all_loaded) return false
            this.is_loading =   true;
            axios.get(
                base_url + this.block.endpoint.ltrim('/').rtrim('/') + '?page=' + this.page + '&per_load=' + this.block.item_per_page
            ).then((resp) => {
                this.is_loading =   false;
                this.page++;

                if (this.page == resp.data.pages) {
                    this.all_loaded =   true;
                }

                let me  =   this;
                resp.data.list.forEach((o) => {
                    me.block.view_items.list.push(o);
                });
            }).catch((error) => {
                this.is_loading =   false;
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/TestimonialBlock.vue